import VueRouter from "vue-router";

//Templates
import Impressum from "../components/PagesContent/Impressum";
import Contact from "../components/PagesContent/Contact";
import Song from "../components/PagesContent/Song";
import Grettings from "../components/PagesContent/Grettings";
import SongTreasure from "../components/PagesContent/SongTreasure";
import WorkAids from "../components/PagesContent/WorkAids";

export default new VueRouter({
    mode: "history",
    routes: [
        {
            name: 'Contact',
            path: '/kontakt',
            component: Contact,
            props: {
                modal: true
            }
        }, {
            name: 'Impressum',
            path: '/impressum',
            component: Impressum,
            props: {
                modal: true
            }
        }, {
            name: 'Song',
            path: '/song/:id',
            component: Song,
            props: {
                modal: true
            }
        }, {
            name: 'Grettings',
            path: '/grusswort',
            component: Grettings,
            props: {
                greetingModal: true
            }
        },{
            name: 'WorkAids',
            path: '/arbeitshilfen',
            component: WorkAids,
            props: {
                modal: true
            }
        },{
            name: 'SongTreasure',
            path: '/liederschatz-wozu',
            component: SongTreasure,
            props: {
                modal: true
            }
        },
    ]
});